import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RolesPermissionsRoutingModule } from './roles-permissions-routing.module';
import { RolesPermissionsComponent } from './roles-permissions.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatLegacyListModule as MatListModule } from '@angular/material/legacy-list';
import { PipesModule } from 'app/shared/pipes/pipes.module';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { RoleService } from './services/roles.service';
import { PermissionService } from './services/permission.service';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { SettingsRolesListComponent } from './@components/roles-list/roles-list.component';
import { SettingsPermissionsListComponent } from './@components/permissions-list/permissions-list.component';
import { MatLegacyRadioModule as MatRadioModule } from '@angular/material/legacy-radio';
import { AddRoleModalComponent } from './@components/add-role-modal/add-role-modal.component';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { TsButtonModule } from 'tsui';
import { PermissionValueComponent } from './@components/permission-value/permission-value.component';

@NgModule({
  providers: [RoleService, PermissionService],
  declarations: [
    RolesPermissionsComponent,
    SettingsRolesListComponent,
    SettingsPermissionsListComponent,
    AddRoleModalComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatMenuModule,
    RolesPermissionsRoutingModule,
    MatProgressBarModule,
    MatCheckboxModule,
    MatListModule,
    PipesModule,
    TsButtonModule,
    MatIconModule,
    MatButtonModule,
    MatRadioModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatTooltipModule,
    PermissionValueComponent,
  ],
})
export class RolesPermissionsModule {}
